import { NavBar } from '@design-system/NavBar';
import { Button } from '@design-system/Button';
import { SettingsPageAccountSection } from './SettingsPageAccountSection';
import { SettingsPagePreferencesSection } from './SettingsPagePreferencesSection';
import { SettingsPageHealthProfileSection } from './SettingsPageHealthProfileSection';
// import { SettingsPageHealthNotificationsSection } from './SettingsPageHealthNotificationsSection';
import { SettingsPagePoliciesSection } from './SettingsPagePoliciesSection';
import useLogout from '@hooks/useLogout';

export const SettingsPage = () => {
  const handleLogout = useLogout();

  return (
    <section className="page-container page-container flex flex-col gap-12" data-testid="settings-page">
      <div className="flex flex-col gap-6 md:gap-12" data-testid="settings-header">
        <NavBar buttonLabel={<span className="max-md:hidden">Account</span>} data-testid="settings-navbar" />

        <h1 className="typography-d2 text-primary font-normal" data-testid="settings-title">
          Settings & Information
        </h1>
      </div>

      <SettingsPageAccountSection data-testid="settings-accountSection" />
      <SettingsPagePreferencesSection data-testid="settings-preferencesSection" />
      <SettingsPageHealthProfileSection data-testid="settings-healthProfileSection" />
      {/* <SettingsPageHealthNotificationsSection /> */}
      <SettingsPagePoliciesSection data-testid="settings-policiesSection" />

      <Button variant="secondary" className="text-error" onClick={handleLogout} data-testid="settings-logoutButton">
        Log out
      </Button>
    </section>
  );
};
